import React from "react";
import TextButton from "@components/TextButton";
import useLanguage from "@src/hooks/useLanguage";

const HelpButton = () => {
  const dictionary = useLanguage();
  return (
    <TextButton
      onClick={() =>
        window.location.replace("https://kasanie.org/faq.html")
      }
    >
      {dictionary.help}
    </TextButton>
  );
};
export default HelpButton;
